interface TrustItem {
  icon: string;
  label: string;
  sub?: string;
}

interface TrustBarProps {
  items?: TrustItem[];
}

const defaultItems: TrustItem[] = [
  { icon: 'ri-star-fill', label: '5.0 Star Rated', sub: 'Google Reviews' },
  { icon: 'ri-sun-line', label: 'Heat & UV Rejection', sub: 'All tint grades' },
  { icon: 'ri-eye-off-line', label: 'Privacy & Style', sub: 'All vehicle types' },
  { icon: 'ri-shield-fill', label: 'Premium Film Only', sub: 'Residential & Commercial' },
];

export default function TrustBar({ items = defaultItems }: TrustBarProps) {
  return (
    <div className="relative z-10 px-6 md:px-12 lg:px-16 -mt-10">
      <div className="max-w-7xl mx-auto">
        <div className="bg-[#111111] border border-white/8 rounded-2xl px-4 md:px-8 py-5 grid grid-cols-2 md:grid-cols-4 gap-0">
          {items.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 px-5 py-3 ${
                i < items.length - 1 ? 'md:border-r border-white/8' : ''
              }`}
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#AAFF00]/10 shrink-0">
                <i className={`${item.icon} text-[#AAFF00] text-base`}></i>
              </div>
              <div>
                <p className="text-white text-sm font-sans font-semibold leading-tight">{item.label}</p>
                {item.sub && <p className="text-white/40 text-[11px] font-sans mt-0.5">{item.sub}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
